
import React from 'react';
import Layout from '@/components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import FinanceApprovalsApproved from '@/components/finance/FinanceApprovalsApproved';

const FinanceApprovalsApprovedPage = () => {
  return (
    <Layout>
      <div className="w-full max-w-full py-8">
        <h1 className="text-3xl font-bold mb-8">Approved Procurements</h1>
        
        <Card className="w-full">
          <CardHeader>
            <CardTitle>Finance Approved Procurements</CardTitle>
          </CardHeader>
          <CardContent>
            <FinanceApprovalsApproved />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default FinanceApprovalsApprovedPage;
